import React from "react";
import PropTypes from "prop-types";
import styles from "./AppContent.module.css";

import { InlineWidget } from "react-calendly";
import { Link } from 'react-scroll';

import { 
  FaPalette, 
  FaDatabase, 
  FaAward, 
  FaLink, 
  FaGithub, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt, 
  FaFacebookMessenger,
  FaHeartbeat
} from "react-icons/fa";

import { BsMouse } from "react-icons/bs";
import { BiChevronDown } from "react-icons/bi";

import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import fujitsu from "../../images/fujitsu.png"; 
import kodego from "../../images/kodego.png"; 
import chrmo from "../../images/chrmo.jpg"; 
import miis from "../../images/miis.jpg"; 
import testdome from "../../images/testdome.jpg";
import eduonix from "../../images/eduonix.jpg";
import freecodecamp from "../../images/freecodecamp.png";
import concati from "../../images/concati.png";
import ccc_admission from "../../images/ccc-admission.gif";
import cemetry_mapping from "../../images/cemetery-map.gif";
import fb_clone from "../../images/fb-clone.gif";
import task_organizer from "../../images/task-organizer.gif";
import chat_cortex from "../../images/chat-cortex.gif";
import valorant from "../../images/valorant.gif";

import { useState, useEffect } from "react";

import AOS from 'aos';

const AppContent = () => {
  const [scroll, setScroll] = useState(0);

  const handleScroll = () => {
    if (window.scrollY > 500) {
      setScroll(1);
    } else {
      setScroll(0);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    AOS.init({
      once: true
    });
  }, []);

  return (
    <div className={styles.AppContent} data-testid="AppContent">
      <div className={styles.AppNavbar}>
        <div className={styles.AppNavbarList}>
          <div className={styles.AppNavbarListItem} data-aos="fade-left" data-aos-duration="500" data-aos-delay="100">
            <Link className='text-decoration-none' to="about">
              [ <span>About</span> ]
            </Link>
          </div>
          <div className={styles.AppNavbarListItem} data-aos="fade-left" data-aos-duration="500" data-aos-delay="200">
            <Link className='text-decoration-none' to="experience">
              [ <span>Experience</span> ]
            </Link>
          </div>
          <div className={styles.AppNavbarListItem} data-aos="fade-left" data-aos-duration="500" data-aos-delay="300">
            <Link className='text-decoration-none' to="projects">
              [ <span>Projects</span> ]
            </Link>
          </div>
          <div className={styles.AppNavbarListItem} data-aos="fade-left" data-aos-duration="500" data-aos-delay="400">
            <Link className='text-decoration-none' to="contact">
              [ <span>Contact</span> ]
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.AppContentBody}>
        <div id="about" className="pt-1"></div>
        <div className={styles.AppAbout} data-aos="fade-right" data-aos-duration="500" data-aos-delay="300">
          <div className={styles.AppAboutWrapper}>
            <div className={styles.AppAboutHeader}>
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>A</b>
                  BOUT ME
                </span>
              </h1>
            </div>
            <div className={styles.AppAboutContent}>
              <p className="m-0">
                Hi! Nice to meet you, my name is Rico or you can call me "Rics". I hold a bachelor's degree in Information Technology. Right now, I
                keep learning and improving my skills in web development using new technologies such
                as frameworks and libraries.
              </p>
              <p className="m-0 mt-3">
                Aside from coding, I enjoy watching anime, listening to music, sharing funny memes, and playing chess.
              </p>
              <p className="m-0 mt-3">
                Explore my portfolio and feel free to contact me if you have any questions and sugggestions.
              </p>
            </div>
            <div className={styles.AppTechStacks + " mt-5"}>
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>T</b>ECHNOLOGY STACKS
                </span>
              </h1>
            </div>
            <div className={styles.AppTechStacksContent}>
              <div className="row gx-3 gy-3">
                <div className="col-lg-6">
                  <div className={styles.AppFrontEnd}>
                    <div className={styles.AppFrontEndHeader}>
                      <FaPalette size={25} />
                      <h4 className="text-center m-2">Front-end Tools</h4>
                    </div>
                    <div className={styles.AppFrontEndContent + " mt-3"}>
                      <div className="row gx-3 gy-3">
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src="https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg"
                              alt=""
                              width="50%"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            Figma
                          </small>
                        </div>
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src="https://www.freepnglogos.com/uploads/javascript-png/javascript-vector-logo-yellow-png-transparent-javascript-vector-12.png"
                              alt=""
                              width="70%"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            Javascript
                          </small>
                        </div>
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src="https://cdn4.iconfinder.com/data/icons/logos-3/600/React.js_logo-512.png"
                              alt=""
                              width="80%"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            React
                          </small>
                        </div>
                        <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                          <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                            <img
                              src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Vue.js_Logo_2.svg/512px-Vue.js_Logo_2.svg.png?20170919082558"
                              alt=""
                              width="80%"
                            />
                          </div>
                          <small
                            className="text-center"
                            style={{ fontSize: "70%" }}
                          >
                            Vue
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className={styles.AppBackEnd}>
                    <div className={styles.AppBackEndHeader}>
                      <FaDatabase size={25} />
                      <h4 className="text-center m-2">Back-end Tools</h4>
                    </div>
                    <div className="row gx-3 gy-3">
                      <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                        <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                          <img
                            src="https://www.logo.wine/a/logo/Laravel/Laravel-Logo.wine.svg"
                            alt=""
                            width="120%"
                            height="120%"
                          />
                        </div>
                        <small
                          className="text-center"
                          style={{ fontSize: "70%" }}
                        >
                          Laravel
                        </small>
                      </div>
                      <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                        <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                          <img
                            src="https://upload.wikimedia.org/wikipedia/commons/2/27/PHP-logo.svg"
                            alt=""
                            width="100%"
                          />
                        </div>
                        <small
                          className="text-center"
                          style={{ fontSize: "70%" }}
                        >
                          PHP
                        </small>
                      </div>
                      <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                        <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                          <img
                            src="https://www.logo.wine/a/logo/MySQL/MySQL-Logo.wine.svg"
                            alt=""
                            width="100%"
                          />
                        </div>
                        <small
                          className="text-center"
                          style={{ fontSize: "70%" }}
                        >
                          MySQL
                        </small>
                      </div>
                      <div className="col-3 d-flex flex-column align-items-center justify-content-center">
                        <div className="p-2 h-100 d-flex align-items-center justify-content-center">
                          <img
                            src="https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png"
                            alt=""
                            width="70%"
                          />
                        </div>
                        <small
                          className="text-center"
                          style={{ fontSize: "70%" }}
                        >
                          Node.js
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.AppMouseWrapper}>
              <div className=
                {styles.AppMouse+` ${scroll > 0 ? styles.AppMouseHide : styles.AppMouseShow}`}
              >
                <BsMouse
                  className="text-white fs-5"
                />
                <BiChevronDown
                  className="text-white fs-5"
                />
              </div>
            </div>
          </div>
        </div>
        <div id="experience" className="pt-1"></div>
        <div className={styles.AppExperience} data-aos="fade-right" data-aos-duration="500" data-aos-delay="400">
          <div className={styles.AppExperienceWrapper}>
            <div className={styles.AppExperienceHeader}>
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>E</b>XPERIENCE
                </span>
              </h1>
            </div>
            <div className={styles.AppExperienceContent+" px-3"}>
              <VerticalTimeline
                layout={ "1-column-left" }
                lineColor={ "#fff" }
                animate={ true }
                className={ styles.AppExprienceTimeline }
              >
                <VerticalTimelineElement
                  className={styles.AppExprienceTimelineElement}
                  contentStyle={{ background: '#2b2b2ba6', color: '#fff'}}
                  contentArrowStyle={{ borderRight: '7px solid #2b2b2ba6' }}
                  date="Sept 2022 - Present"
                  dateClassName={ styles.AppExperienceDate }
                  iconStyle={{ background: '#00ba7c', color: '#fff', width: '20px', height: '20px', marginLeft: '10px', marginTop: '10px' }}
                  // icon={<FaLink size={10} color="#fff" />}
                  visible={false}
                  iconClassName={styles.Icon}
                >
                  <div className="d-lg-flex align-items-center justify-content-between">
                    <div className={styles.JobDescription}>
                      <h4 className={styles.Position}>Full Stack Web Developer</h4>
                      <div className="d-flex gap-2 mb-2">
                        <img src={fujitsu} alt="kodego" width="20px" height="20px" className=""/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Fujitsu Die-Tech Corporation of the Philippines
                        </p>
                      </div>
                      <ul className={styles.JobHighlights}>
                        <li>
                          Utilizing Laravel and Vue JS to develop a web-based application for the company.
                        </li>
                        <li>
                          Collaborating with the team to test and debug the company's web systems.
                        </li>
                        <li>
                          Developed Systems: Locker Management System · Safety and Health Management System.
                        </li>
                      </ul>
                    </div>
                  </div>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                  className={styles.AppExprienceTimelineElement}
                  contentStyle={{ background: '#2b2b2ba6', color: '#fff'}}
                  contentArrowStyle={{ borderRight: '7px solid #2b2b2ba6' }}
                  date="Apr 2022 - Aug 2022"
                  dateClassName={ styles.AppExperienceDate }
                  iconStyle={{ background: '#00ba7c', color: '#fff', width: '20px', height: '20px', marginLeft: '10px', marginTop: '10px' }}
                  visible={false}
                  iconClassName={styles.Icon}
                >
                  <div className="d-lg-flex align-items-center justify-content-between">
                    <div className={styles.JobDescription}>
                      <h4 className={styles.Position}>Bootcamp Student</h4>
                      <div className="d-flex gap-2 mb-2">
                        <img src={kodego} alt="kodego" width="20px" height="20px" className=""/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          KodeGo Bootcamp
                        </p>
                      </div>
                      <ul className={styles.JobHighlights}>
                        <li>
                          Joined collaborative hackathon for the first time and won
                          1st place.
                        </li>
                        <li>
                          Created web projects and a capstone.
                        </li>
                        <li>
                          Learned how to use frameworks and libraries such as ReactJS
                          and Laravel as an API.
                        </li>
                      </ul>
                    </div>
                    <div className="p-lg-5 p-3 text-center">
                      <a
                        href="https://assets.kodego.ph/public/isa/wrBkkpRIHG3pPCnEqNY0H5yQuERKmDm0foARc8b2.pdf"
                        className="d-flex text-decoration-none gap-1"
                        target="_blank"
                      >
                        <button className={styles.BtnViewCert+" btn btn-outline-primary rounded-5 d-flex align-items-center justify-content-center "}>
                          <FaAward size={28} />
                          <p className="m-0">View Certificate</p>
                        </button>
                      </a>
                    </div>
                  </div>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                  className={styles.AppExprienceTimelineElement}
                  contentStyle={{ background: '#2b2b2ba6', color: '#fff'}}
                  contentArrowStyle={{ borderRight: '7px solid #2b2b2ba6' }}
                  date="Apr 2022 - Jul 2022"
                  dateClassName={ styles.AppExperienceDate }
                  iconStyle={{ background: '#00ba7c', color: '#fff', width: '20px', height: '20px', marginLeft: '10px', marginTop: '10px' }}
                  visible={false}
                  iconClassName={styles.Icon}
                >
                  <div className="d-lg-flex align-items-center justify-content-between">
                    <div className={styles.JobDescription}>
                      <h4 className={styles.Position}>Junior Web Developer</h4>
                      <div className="d-flex gap-2 mb-2">
                        <img src={chrmo} alt="kodego" width="20px" height="20px" className=""/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Calamba City Human Resource Management Office · Internship
                        </p>
                      </div>
                      <ul className={styles.JobHighlights}>
                      
                        <li>
                          Created a web-based application for the Calamba Municipality.
                        </li>
                        <li>
                          Used Laravel Framework.
                        </li>
                        <li>
                          Learned GitHub and basic MVC (Model-View-Controller) framework.
                        </li>
                      </ul>
                    </div>
                    <div className="p-lg-5 p-3 text-center">
                      <a
                        href="https://drive.google.com/file/d/1Qnze9TggBCrMfUKHNCtIvDB1uQUiEX6c/view"
                        className="d-flex text-decoration-none gap-1"
                        target="_blank"
                      >
                        <button className={styles.BtnViewCert+" btn btn-outline-primary rounded-5 d-flex align-items-center justify-content-center "}>
                          <FaAward size={28} />
                          <p className="m-0">View Certificate</p>
                        </button>
                      </a>
                    </div>
                  </div>
                </VerticalTimelineElement> 
              </VerticalTimeline>
            </div>
          </div>
        </div>
        <div className={styles.AppCertificate}>
          <div className={styles.AppCertificateWrapper}>
            <div className={styles.AppCertificateHeader} data-aos="fade-right" data-aos-duration="500" data-aos-delay="300">
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>C</b>ERTIFICATES
                </span>
              </h1>
            </div>
            <div className="row g-3">
              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="400">
                <a
                  href="https://drive.google.com/file/d/1GJQPih-6n8BmfKEBHOSVjmA5-WFy4_ll/view?usp=sharing"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>Kaizen Symposium</span>
                      </h6>
                      <div className="d-flex">
                        <img src={fujitsu} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Fujitsu Die-Tech Corp. of the Philippines
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="400">
                <a
                  href="https://drive.google.com/file/d/18lm_6sFSsAnThm_mlWZJgeXAOD0u5egI/view"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>Elevate Hackathon</span>
                      </h6>
                      <div className="d-flex">
                        <img src={concati} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Concati & KodeGo
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="500">
                <a
                  href="https://www.testdome.com/certificates/cfcca8cc568b451f90b1260b86bcf96d"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>PHP Certificate</span>
                      </h6>
                      <div className="d-flex">
                        <img src={testdome} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          TestDome
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>
              
              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="600">
                <a
                  href="https://www.testdome.com/certificates/1306b05b71984d378da7733001c7341e"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>MySQL and SQL Certificate</span>
                      </h6>
                      <div className="d-flex">
                        <img src={testdome} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          TestDome
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="700">
                <a
                  href="https://www.eduonix.com/certificate/e43f1c027d"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>JavaScript and jQuery Course</span>
                      </h6>
                      <div className="d-flex">
                        <img src={eduonix} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          Eduonix
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="800">
                <a
                  href="https://www.freecodecamp.org/certification/rics/javascript-algorithms-and-data-structures"
                  className="text-decoration-none gap-1"
                  target="_blank"
                >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span>JavaScript Algorithms and Data Structures</span>
                      </h6>
                      <div className="d-flex">
                        <img src={freecodecamp} width="20px" height="20px" className="me-1"/>
                        <p className={styles.CompanyName + " m-0 text-white"}>
                          freeCodeCamp
                        </p>
                      </div>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div>
              {/* COMING SOON  */}
              {/* <div className="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-duration="500" data-aos-delay="900">
                <a className="text-decoration-none gap-1" >
                  <div className={styles.AppCertificateContent+" d-flex align-items-center justify-content-between "}>
                    <div className={styles.AppCertificateContentHeader}>
                      <h6 className={styles.AppCertificateContentHeaderTitle}>
                        <span className={styles.ComingSoon}>Coming soon</span>
                      </h6>
                    </div>
                    <div className={styles.ViewCert}>
                      <FaAward size={25}/>
                    </div>
                  </div>
                </a>
              </div> */}
            </div>
          </div>
        </div>
        <div id="projects" className="pt-1"></div>
        <div className={styles.AppProjects}>
          <div className={styles.AppProjectWrapper}>
            <div div className={styles.AppProjectHeader} data-aos="fade-right" data-aos-duration="500" data-aos-delay="450">
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>P</b>ROJECTS
                </span>
              </h1>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="700">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Chat Cortex</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://chat-cortex.vercel.app" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">chat-cortex.vercel.app</small>
                      </a>
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/chat-cortex" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/chat-cortex</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mt-2 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">VueJS</small>
                        <small className="badge bg-success">OpenAI</small>
                        <small className="badge bg-success mx-1">ChatGPT</small>
                      </div>
                      
                    </div>
                    <small>Chat Cortex will answer all your questions and it was powered by ChatGPT.</small>
                  </div>
                  <img src={chat_cortex}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="700">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Task Organizer</h5>
                    {/* <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://task-organizer.up.railway.app" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">task-organizer.up.railway.app</small>
                      </a>
                    </div> */}
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/laravel-task-organizer" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/laravel-task-organizer</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mt-2 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">Laravel</small>
                        <small className="badge bg-success">Bootstrap</small>
                        <small className="badge bg-success mx-1">MySQL</small>
                      </div>
                      
                    </div>
                    <small>A simple task management app where you can add, edit, and delete tasks.</small>
                  </div>
                  <img src={task_organizer}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="700">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Facebook Clone</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://fb-clone-react-sigma.vercel.app" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">fb-clone-react-sigma.vercel.app</small>
                      </a>
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/fb-clone-react" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/fb-clone-react</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mt-2 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">ReactJS</small>
                        <small className="badge bg-success">Bootstrap</small>
                        <small className="badge bg-success mx-1">CSS</small>
                      </div>
                      
                    </div>
                    <small>First project using React JS. This app does not intend to use for any fraud such as phishing.</small>
                  </div>
                  <img src={fb_clone}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="800">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Valorant E-commerce Design</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://coricss.github.io/valorant-ecommerce-design" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss.github.io/valorant-ecommerce-design</small>
                      </a>
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/valorant-ecommerce-design" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/valorant-ecommerce-design</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">HTML</small>
                        <small className="badge bg-success me-1">CSS</small>
                      </div>
                      <div className="col">
                      <small className="badge bg-success">Bootstrap</small>
                        <small className="badge bg-success m-1">JavaScript</small>
                      </div>
                    </div>
                    <small>Multipage e-commerce design for Valorant gun skins.</small>
                  </div>
                  <img src={valorant}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="500">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Student Admission Management</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://ccc-admission.epizy.com " target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">ccc-admission.epizy.com </small>
                      </a>
                    </div>
                    {/* <div className="mb-1 d-flex">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/ccc-admission" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/ccc-admission</small>
                      </a>
                    </div> */}
                    <div className="row row-cols-auto g-0 mt-2 mb-1">
                      <div className="col">
                        <small className="badge bg-success me-1">Bootstrap</small>
                        <small className="badge bg-success me-1">JavaScript</small>
                      </div>
                      <div className="col">
                        <small className="badge bg-success">PHP</small>
                        <small className="badge bg-success m-1">MySQL</small>
                      </div>
                    </div>
                    <small>Online pre-registration with LAN-based Entrace Examination for Student Admission in City College of Calamba.</small>
                  </div>
                  <img src={ccc_admission}></img>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right" data-aos-duration="500" data-aos-delay="600">
                <div className={styles.AppProjectContent+" position-relative"}>
                  <div className={styles.AppProjectOverlay+" p-2 d-lg-none"}>
                    <p className="text-white m-0 text-center">Tap for details</p>
                  </div>
                  <div className={styles.AppProjectBackdrop+" d-lg-flex"}>
                    <h5 className="text-white">Cemetery Mapping</h5>
                    <div class="d-inline-flex align-items-center">
                      <FaLink className="me-1"/>
                      <a href="https://divinelifememorialpark.great-site.net" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">divinelifememorialpark.great-site.net</small>
                      </a>
                    </div>
                    <div class="mb-1 d-flex align-items-center">
                      <FaGithub className="me-1"/>
                      <a href="https://github.com/coricss/cemetery-mapping" target="_blank" className="text-white text-decoration-none">
                        <small className="fw-bold">coricss/cemetery-mapping</small>
                      </a>
                    </div>
                    <div className="row row-cols-auto g-0 mb-1">
                      <div className="col">
                        <small className="badge bg-success">Bootstrap</small>
                        <small className="badge bg-success mx-1">CSS</small>
                        <small className="badge bg-success me-1">JavaScript</small>
                      </div>
                      <div className="col">
                        <small className="badge bg-success">PHP</small>
                        <small className="badge bg-success m-1">MySQL</small>
                      </div>
                    </div>
                    <small>Track your deceased family member's grave.</small>
                  </div>
                  <img src={cemetry_mapping}></img>
                </div>
              </div>
            </div>
            
          </div>
        </div>
        <div id="contact" className="pt-1"></div>
        <div className={styles.AppContact} data-aos="fade-right" data-aos-duration="500" data-aos-delay="300">
          <div className={styles.AppContactWrapper}>
            <div div className={styles.AppContactHeader}>
              <h1 className="text-lg-start text-center">
                <span>
                  <b style={{ fontSize: "3rem" }}>L</b>ET'S GET IN TOUCH
                </span>
              </h1>
            </div>
            <div className={styles.AppContactBody}>
              <div className={styles.AppContactContent}>
                <div className="mb-4">
                  <p>
                    Feel free to message me if you have any questions or want to work with me. You can find my contact details below and I'll do my best to respond as soon as possible.
                  </p>
                </div>
                <div className="row g-3 mb-4">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="d-flex align-items-center justify-content-center">
                      <div>
                        <div className="d-flex align-items-center mb-2">
                          <FaPhoneAlt className={styles.AppContactIcons+" me-2"}/>
                          <a href="tel:09319542169" className={styles.AppContactLink+" m-0 text-decoration-none text-white"}>09319542169</a>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <FaEnvelope className={styles.AppContactIcons+" me-2"}/>
                          <a href="mailto:guinanaorico@gmail.com" className={styles.AppContactLink+" m-0 text-decoration-none text-white"}>guinanaorico@gmail.com</a>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                          <FaMapMarkerAlt className={styles.AppContactIcons+" me-2"}/>
                          <a href="https://www.google.com/maps/place/Calamba,+4027+Laguna/@14.1865838,121.1205693,2693m/data=!3m1!1e3!4m5!3m4!1s0x33bd63655ce077d3:0x39dd1f59c6edaced!8m2!3d14.1876712!4d121.1250825" target="_blank" className={styles.AppContactLink+" m-0 text-decoration-none text-white"}>Calamba, Laguna, Philippines</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="d-flex align-items-center justify-content-center h-100">
                        <a className="" href="https://www.facebook.com/messages/t/ricstrbo" target="_blank">
                          <button className={styles.AppMessenger+" btn btn-primary rounded-5 btn-lg"}>
                            <FaFacebookMessenger className="me-2"/>
                            <small>Chat me</small>
                          </button>
                        </a>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <InlineWidget
                    styles={{padding: "0px", height: "800px", width: "100%", overflow: "hidden"}}
                    url="https://calendly.com/guinanaorico/discovery-session?hide_gdpr_banner=1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <div className="text-white text-center p-4">
            Created with <FaHeartbeat className="text-success mx-1"/> by <a href="https://github.com/coricss" className="text-decoration-none text-success fw-bold">Rico Guinanao</a>
          </div>
        </footer>
      </div>
    </div>
  );
};

AppContent.propTypes = {};

AppContent.defaultProps = {};

export default AppContent;
